import { render } from "./ErrorGlobalModal.vue?vue&type=template&id=6042539c"
import script from "./ErrorGlobalModal.vue?vue&type=script&lang=js"
export * from "./ErrorGlobalModal.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\src\\Nordlux.Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__